import { useState, useCallback } from "react";
import axios from "axios";
import { FAST_API_BASE_URL } from "constants";

const useGoogleOAuth = (domainId) => {
  const [oauthLoading, setOauthLoading] = useState(false);

  const initiateOAuth = useCallback(async () => {
    if (!domainId) return;

    setOauthLoading(true);

    try {
      const res = await axios.get(`${FAST_API_BASE_URL}/api/google-calendar/auth`, {
        headers: { "DOMAIN-TOKEN": domainId },
      });

      if (res?.data?.result?.auth_url) {
        sessionStorage.setItem("oauth_domain_id", domainId);
        sessionStorage.setItem("oauth_redirect_origin", window.location.href);

        window.location.href = res.data.result.auth_url;
      } else {
        throw new Error("No auth URL received");
      }
    } catch (err) {
      console.error("Failed to initiate Google auth:", err);
      setOauthLoading(false);
      return { success: false, message: "Failed to connect to Google Calendar." };
    }
  }, [domainId]);

  return {
    oauthLoading,
    initiateOAuth,
  };
};

export default useGoogleOAuth;